export var VERIFY_TYPE_VALUE;
(function (VERIFY_TYPE_VALUE) {
    VERIFY_TYPE_VALUE[VERIFY_TYPE_VALUE["\u672A\u8BA4\u8BC1"] = 0] = "\u672A\u8BA4\u8BC1";
    VERIFY_TYPE_VALUE[VERIFY_TYPE_VALUE["\u4E2A\u4EBA\u8BA4\u8BC1"] = 1] = "\u4E2A\u4EBA\u8BA4\u8BC1";
    VERIFY_TYPE_VALUE[VERIFY_TYPE_VALUE["\u8BA4\u8BC1\u5BA1\u6838\u4E2D"] = -1] = "\u8BA4\u8BC1\u5BA1\u6838\u4E2D";
    VERIFY_TYPE_VALUE[VERIFY_TYPE_VALUE["\u4F01\u4E1A\u8BA4\u8BC1"] = 2] = "\u4F01\u4E1A\u8BA4\u8BC1";
    VERIFY_TYPE_VALUE[VERIFY_TYPE_VALUE["\u8BA4\u8BC1\u5F85\u5BA1\u6838"] = -3] = "\u8BA4\u8BC1\u5F85\u5BA1\u6838";
    VERIFY_TYPE_VALUE[VERIFY_TYPE_VALUE["\u8BA4\u8BC1\u672A\u901A\u8FC7"] = -2] = "\u8BA4\u8BC1\u672A\u901A\u8FC7";
})(VERIFY_TYPE_VALUE || (VERIFY_TYPE_VALUE = {}));
